import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// Components
import Navbar from "../containers/Home/Navbar";
import UpdateProfileForm from "../containers/Profile/UpdateProfileForm";
import UpdatePasswordForm from "../containers/Profile/UpdatePasswordForm";
import UpdateProfileImage from "../containers/Profile/UpdateProfileImage";
import BackToEditor from "../components/UI/BackToEditor";

//
import useAuth from "../utils/hooks/useAuth";

const Profile = () => {
  const user = useSelector((state) => state.user.user);
  const { t } = useTranslation();

  useAuth({
    authRequired: true,
    redirectTo: "/",
  });

  return (
    <>
      <Navbar />
      <BackToEditor />
      <main className="landing-home content px-0 px-md-3">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="form-wrapper mt-5">
                <h3 className="mb-3">{t("profile.formTitle")}</h3>
                <UpdateProfileForm initialValues={user} />
                <UpdatePasswordForm />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="form-wrapper my-5">
                <UpdateProfileImage />
              </div>
              <div className="form-wrapper my-5">
                <h3>{t("profile.deleteAccountLink")}</h3>
                <Link to="/delete" className="text-danger">{t("profile.deleteAccountLink")}</Link>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Profile;
